import React from 'react';
import Chip, { ChipProps } from '@mui/material/Chip';
import HistoryToggleOffIcon from '@mui/icons-material/HistoryToggleOff';

import LargeCheckIcon from 'assets/images/BulkStatus/LargeCheck.svg';
import LargeXIcon from 'assets/images/BulkStatus/LargeX.svg';
import PendingIcon from 'assets/images/BulkStatus/Pending.svg';
import {
  PROVISIONING_STATUS_LABEL,
  ProvisioningStatusLabel,
} from '../constants/provisioningStatus.ts';
import { pxToRem } from 'common/utils/fonts.ts';
import { DEFAULT_BORDER_RADIUS } from 'theme/constants.ts';

type BulkProvisioningStatusChipProps = {
  status?: ProvisioningStatusLabel;
};

export const BulkProvisioningStatusChip: React.FC<BulkProvisioningStatusChipProps> = ({
  status,
}) => {
  let color: ChipProps['color'] = 'default';
  let icon = <HistoryToggleOffIcon />;

  if (
    status === PROVISIONING_STATUS_LABEL.DATA_EXTRACTION_FAILED ||
    status === PROVISIONING_STATUS_LABEL.PROCESSING_FAILED
  ) {
    color = 'failed';
    icon = <LargeXIcon width={pxToRem(24)} height={pxToRem(24)} />;
  }

  if (status === PROVISIONING_STATUS_LABEL.PROCESSING_SUCCEED) {
    color = 'success';
    icon = <LargeCheckIcon width={pxToRem(24)} height={pxToRem(24)} />;
  }

  if (
    status === PROVISIONING_STATUS_LABEL.PROCESSING_IN_PROGRESS ||
    status === PROVISIONING_STATUS_LABEL.DATA_EXTRACTION_IN_PROGRESS ||
    status === PROVISIONING_STATUS_LABEL.DATA_EXTRACTION_PENDING
  ) {
    color = 'info';
    icon = <PendingIcon width={pxToRem(24)} height={pxToRem(24)} />;
  }

  return (
    <Chip
      color={color}
      icon={icon}
      label={status}
      sx={{
        height: pxToRem(28),
        '& .MuiChip-icon': {
          ml: 6,
          borderRadius: DEFAULT_BORDER_RADIUS,
          mr: 0,
        },
        '& .MuiChip-label': {
          pl: 4,
          pr: 8,
        },
      }}
    />
  );
};
